export default __webpack_public_path__ + "static/media/l_wdt_c_5.b7788922.mp3";